/*
 * Jira Ticket:
 * Created Date: Wed, 3rd Jun 2020, 14:53:50 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import list from './list';
import create from './create';
import edit from './edit';
import icon from '@material-ui/icons/Settings';

export default {
  list,
  create,
  edit,
  icon,
};
